import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DEVTOOLS_OPTIONS } from '@/modules/debug/constants/zustand';

interface State {
  disabledElementIds: string[];
}

interface Methods {
  getDisabled(): string[];
  setDisabled(ids: string[]): void;
}

const INITIAL_STATE: State = {
  disabledElementIds: [],
};

interface IStore extends State, Methods {}
export const useStore = create<IStore>()(
  devtools(
    (set, get) => ({
      ...INITIAL_STATE,

      getDisabled() {
        return get().disabledElementIds;
      },

      setDisabled(ids) {
        set(
          {
            disabledElementIds: ids,
          },
          undefined,
          {
            type: 'disabledElementIds/set',
            ...DEVTOOLS_OPTIONS,
          },
        );
      },
    }),
    { store: 'disabledElementStore', ...DEVTOOLS_OPTIONS },
  ),
);
